import { generateClient } from 'aws-amplify/data';
import type { Schema } from '@backend/data/resource';

export const client = generateClient<Schema>();